import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  OnDestroy
} from '@angular/core';
import { AzureSearchService } from '../../../essentials/azure/search/search.service';

import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { HeaderService } from '../header.service';

@Component({
  selector: 'fcp-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit, OnDestroy {
  @ViewChild('inputSearch') inputSearch: ElementRef;
  public results;
  public viewResults = [];
  public suggestions = [];
  public amountOfResults = '';
  public isVisibleLabelSearch: boolean;
  public open: boolean;
  public loading: boolean;
  public showSearch: boolean;
  public inputForSearch: string;
  public page = 1;

  public buttons = [
    { color: 'Fundo Prim�rio', title: 'Tudo' },
    { color: 'Fundo Prim�rio', title: 'Páginas' },
    { color: 'Fundo Prim�rio', title: 'Notícias' },
    { color: 'Fundo Prim�rio', title: 'Publicações' }
  ];

  private subscriptionsArray: Subscription[];

  constructor(
    private azureService: AzureSearchService,
    private router: Router,
    private route: ActivatedRoute,
    private headerService: HeaderService
  ) {
    this.subscriptionsArray = [];
    const routSub = this.route.queryParams.subscribe(params => {
      if (
        location.pathname.indexOf('/publicacoes') < 0 &&
        location.pathname.indexOf('/noticias') < 0
      ) {
        if (params['q']) {
          this.open = true;
          if (params['p']) {
            this.page = params['p'];
          }
          this.inputForSearch = params['q'];
          this.search(params['q']);
        }
      }
    });
    this.subscriptionsArray.push(routSub);
  }

  ngOnInit() {
    const closeSearchSubscrition = this.headerService.closeSearchEmitter.subscribe(
      value => (this.open = value)
    );
    this.subscriptionsArray.push(closeSearchSubscrition);
  }

  ngOnDestroy() {
    this.subscriptionsArray.forEach(sub => sub.unsubscribe());
  }

  public search(term) {
    this.loading = true;
    const azureSub = this.azureService
      .getCognitiveSearch(term)
      .subscribe((response: any) => {
        this.results = response.value;
        this.showSearch = true;
        this.viewResults = response.value;
        this.loading = false;
        const amount = this.results.length;
        this.amountOfResults =
          amount === 0
            ? `Não foram encontrados resultados`
            : amount > 1
            ? `Foram encontrados ${amount} resultados`
            : `Foi encontrado ${amount} resultado`;

        this.filterSearch(this.buttons[0]);
      });
    this.subscriptionsArray.push(azureSub);
  }

  public getSuggestions(term) {
    this.showSearch = false;
    const azureSub = this.azureService
      .getSuggestions(term)
      .subscribe(response => {
        this.suggestions = response;
      });
    this.subscriptionsArray.push(azureSub);
  }

  public mapInputValue($event, search?: boolean) {
    const searchTerm = this.inputForSearch;
    const key = $event.key ? $event.key.toLowerCase() : null;

    this.isVisibleLabelSearch = searchTerm.trim().length > 3 ? true : false;

    if (searchTerm && searchTerm.length > 1) {
      if (key === 'enter' || search) {
        search = true;
      }
      this.clearData();
      if (search) {
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { q: searchTerm }
        });
        this.search(searchTerm);
      } else {
        this.getSuggestions(searchTerm);
      }
    }
  }

  public openSearch() {
    this.results = [];
    this.suggestions = [];
    this.amountOfResults = '';
    this.open = !this.open;
    setTimeout(x => {
      if (this.open) {
        this.inputSearch.nativeElement.focus();
      }
    }, 100);
    if (!this.open) {
      this.inputForSearch = '';
      this.page = 1;
      this.clearData();
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {}
      });
    }
  }

  public goToPage(url) {
    this.openSearch();
    this.router.navigate([url]);
  }

  public filterSearch($event) {
    this.viewResults = [];
    const search = this.results;
    if ($event.title === 'Tudo' || $event.button.title === 'Tudo') {
      this.viewResults = search;
      return;
    }

    this.viewResults = search.filter(item => {
      if (item.type === $event.button.title) {
        return item;
      }
    });
  }

  public clearData() {
    this.results = [];
    this.viewResults = [];
    this.suggestions = [];
    this.amountOfResults = '';
  }

  public changePage(page) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { p: page },
      queryParamsHandling: 'merge'
    });
  }
}
